export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "app.830cc56.worker.js");
}
